// Central config — hardcoded backend URL.
// The Vercel env var was unreliable, so we pin it here.
// To change the backend, edit this single file.
const BACKEND_URL = 'https://api.dmstuned.eu';

export const API      = `${BACKEND_URL}/api`;
export const API_BASE = BACKEND_URL;
export const WS_BASE  = BACKEND_URL
  .replace('https://', 'wss://')
  .replace('http://', 'ws://');

export default BACKEND_URL;
